import {
  categoriesFilterButtons,
  quickFilterById,
  quickFiltersCategories,
  TCategoryFilterButton,
  TQuickFilter,
  TQuickFiltersCategory,
} from "@store/actions/quickFilters";

import { createSlice } from "@reduxjs/toolkit";

export type QuickFiltersState = {
  quickFilter?: TQuickFilter | null;
  quickFiltersCategories?: { data: TQuickFiltersCategory[]; pageCount: number };
  categoriesFilterButtons?: TCategoryFilterButton[];
  isLoading: boolean;
};

const initialState: QuickFiltersState = {
  isLoading: false,
  quickFilter: null,
  quickFiltersCategories: { data: [], pageCount: 0 },
  categoriesFilterButtons: [],
};

const { actions, reducer } = createSlice({
  name: "quickFilters",
  initialState,
  reducers: {
    resetQuickFilter: (state) => {
      state.quickFilter = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(quickFiltersCategories.fulfilled, (state, { payload }) => {
      if (!payload) {
        return;
      }

      state.quickFiltersCategories = payload;
      state.isLoading = false;
    });
    builder.addCase(quickFiltersCategories.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(categoriesFilterButtons.fulfilled, (state, { payload }) => {
      state.categoriesFilterButtons = payload;
    });

    builder.addCase(quickFilterById.fulfilled, (state, { payload }) => {
      state.quickFilter = payload;
    });
  },
});

export const { resetQuickFilter } = actions;

export default reducer;
